module.exports = __webpack_public_path__ + "img/default-BFT.e0e53217.svg";